//This file is use to add custom symbols for line charts or others that needed
//if you want to add a new symbol please use the same structure as the below items

//add a custom cross symbol
Highcharts.SVGRenderer.prototype.symbols.cross = function (x, y, w, h) {
    return ['M', x, y, 'L', x + w, y + h, 'M', x + w, y, 'L', x, y + h];
};

//add a custom pentagon symbol
Highcharts.SVGRenderer.prototype.symbols.pentagon = function (x, y, w, h) {
    // Calculate the center point of the pentagon
    const centerX = x + w / 2;
    const centerY = y + h / 2;

    // Calculate the radius of the pentagon (assuming it fits within the width/height)
    const radius = Math.min(w / 1.7, h / 1.7);

    // Calculate the angles of the pentagon's vertices
    const angles = [0, 72, 144, 216, 288];

    // Create the path for the pentagon
    // Start at first vertex
    const startAngle = (angles[0] - 16) * Math.PI / 180;
    let path = ['M',
        centerX + radius * Math.cos(startAngle),
        centerY + radius * Math.sin(startAngle)
    ];
    // Draw remaining edges
    for (let i = 1; i < 5; i++) {
        const angle = (angles[i] - 16) * Math.PI / 180;
        path.push(
            'L',
            centerX + radius * Math.cos(angle),
            centerY + radius * Math.sin(angle)
        );
    }
    path.push('Z');

    return path;
};

//add a custom star symbol
Highcharts.SVGRenderer.prototype.symbols.star = function (x, y, w, h) {
    // Calculate the center point of the star
    const centerX = x + w / 2;
    const centerY = y + h / 2;

    // Calculate the radius of the star's outer points (assuming it fits within the width/height)
    const outerRadius = Math.min(w / 2, h / 2);

    // Calculate the radius of the star's inner points
    const innerRadius = outerRadius * 0.38; // Adjust this value to change the star's sharpness

    // Calculate the angles of the star's vertices
    const angles = [0, 36, 72, 108, 144, 180, 216, 252, 288, 324];

    // Move to first point
    const firstAngle = (angles[0] - 18) * Math.PI / 180;
    let path = ['M',
        centerX + outerRadius * Math.cos(firstAngle),
        centerY + outerRadius * Math.sin(firstAngle)    ];
    // Draw remaining points alternating radii
    for (let i = 1; i < 10; i++) {
        const angle = (angles[i] - 18) * Math.PI / 180;
        const r = i % 2 === 0 ? outerRadius : innerRadius;
        path.push('L',
            centerX + r * Math.cos(angle),
            centerY + r * Math.sin(angle)
        );
    }
    path.push('Z');

    return path;
};